/**
 * auth_token cookie 读写工具。
 *
 * 后端鉴权（backend/pkg/server/filters/authentication.go 的 tokenFromRequest）在缺少
 * Authorization 头时会回退到名为 `auth_token` 的 cookie，值为裸 token（无 "Bearer " 前缀）。
 * 这里在登录成功 / 恢复登录态时把 token 同步写入该 cookie，登出 / 401 时清除，
 * 使得那些无法自定义请求头的场景（浏览器直开链接、iframe、下载等）也能携带鉴权。
 *
 * 注意：cookie 由前端 JS 写入，故不可能是 httpOnly；它只是 localStorage 里 token 的镜像，
 * token 的真正有效性仍由后端校验，cookie 过期只会让该 cookie 消失。
 */

const AUTH_TOKEN_COOKIE = 'auth_token';
/** 未显式提供 token 有效期时的兜底 Max-Age（7 天）。 */
const DEFAULT_MAX_AGE_SEC = 60 * 60 * 24 * 7;

function secureAttr(): string {
  return typeof location !== 'undefined' && location.protocol === 'https:' ? '; Secure' : '';
}

/** 写入 auth_token cookie。maxAgeSec<=0 时退化为会话 cookie（不设 Max-Age）。 */
export function writeAuthTokenCookie(token: string, maxAgeSec: number = DEFAULT_MAX_AGE_SEC): void {
  if (!token) {
    clearAuthTokenCookie();
    return;
  }
  const maxAge = maxAgeSec > 0 ? `; Max-Age=${Math.floor(maxAgeSec)}` : '';
  document.cookie = `${AUTH_TOKEN_COOKIE}=${encodeURIComponent(token)}; Path=/; SameSite=Lax${maxAge}${secureAttr()}`;
}

/** 清除 auth_token cookie。 */
export function clearAuthTokenCookie(): void {
  document.cookie = `${AUTH_TOKEN_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax${secureAttr()}`;
}
